export enum MediaType {
  MOBILE_S,
  MOBILE,
  TABLET,
  DESKTOP,
  DESKTOP_L,
}

export enum MediaQuery {
  DESKTOP_L = '(min-width: 1475px)',
  DESKTOP = '(min-width: 1168px) and (max-width: 1475px)',
  TABLET = '(min-width: 1016px) and (max-width: 1168px)',
  MOBILE = '(min-width: 658px) and (max-width: 1016px)',
  MOBILE_S = '(max-width: 658px)',
}

export enum GameType {
  DESKTOP = 'allowed_desktop',
  MOBILE = 'allowed_mobile',
}
